import { toPng } from 'html-to-image';
import { ParsedMarkdown } from '../types';

interface ExportControlsProps {
  parsedData: ParsedMarkdown | null;
  fileName: string;
}

export default function ExportControls({ parsedData, fileName }: ExportControlsProps) {
  const handleExportPNG = async () => {
    const element = document.querySelector('.react-flow') as HTMLElement;
    if (!element) return;

    try {
      const dataUrl = await toPng(element, {
        backgroundColor: '#ffffff',
        pixelRatio: 2,
      });

      const link = document.createElement('a');
      link.download = `${fileName.replace('.md', '')}-mindmap.png`;
      link.href = dataUrl;
      link.click();
    } catch (error) {
      console.error('Failed to export PNG:', error);
      alert('Failed to export PNG. Please try again.');
    }
  };

  const handleExportJSON = () => {
    if (!parsedData) return;

    const json = JSON.stringify(parsedData, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.download = `${fileName.replace('.md', '')}-parsed.json`;
    link.href = url;
    link.click();

    URL.revokeObjectURL(url);
  };

  if (!parsedData) return null;

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '12px',
        zIndex: 10,
      }}
    >
      <button
        onClick={handleExportPNG}
        style={{
          padding: '12px 20px',
          background: '#3b82f6',
          color: '#ffffff',
          border: 'none',
          borderRadius: '8px',
          fontWeight: 'bold',
          fontSize: '14px',
          cursor: 'pointer',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#2563eb';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#3b82f6';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        📥 Export PNG
      </button>

      <button
        onClick={handleExportJSON}
        style={{
          padding: '12px 20px',
          background: '#10b981',
          color: '#ffffff',
          border: 'none',
          borderRadius: '8px',
          fontWeight: 'bold',
          fontSize: '14px',
          cursor: 'pointer',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#059669';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#10b981';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        📄 Export JSON
      </button>

      <div
        style={{
          padding: '12px 16px',
          background: '#f8fafc',
          border: '2px solid #e2e8f0',
          borderRadius: '8px',
          fontSize: '12px',
          color: '#64748b',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <span style={{ fontWeight: 'bold' }}>{parsedData.qaPairs.length}</span> nodes
        <span>•</span>
        <span style={{ fontWeight: 'bold' }}>{parsedData.conflicts.length}</span> conflicts
      </div>
    </div>
  );
}
